import CheckoutHeader from '@theme/components/cart/CheckoutHeader'
import FooterBottom from '@theme/components/shop/FooterBottom'
import FooterMain from '@theme/components/shop/FooterMain'
import JavascriptRequired from '@theme/components/shop/JavascriptRequired'
import LayoutCheckoutAboveHeaderHook from '@theme/components/cart/LayoutCheckoutAboveHeaderHook'

export default {
  components: {
    CheckoutHeader,
    FooterBottom,
    FooterMain,
    JavascriptRequired,
    LayoutCheckoutAboveHeaderHook,
  },
}
